import React from 'react'
import PropTypes from 'prop-types'
import { GroupEventsSearchFindResultsState } from '@layouts/group-events-search'
import isEqual from 'lodash/isEqual'
import Router from 'next/router'
import { path as Rpath } from 'ramda'
import { findResultsState } from 'react-instantsearch-dom/server'
import { milesToMeters } from '@lib/conversions'
import {
  updateAfterMilliseconds,
  createURL,
  searchClient,
  pathToSearchState,
  searchStateToURL,
  DEFAULT_PROPS,
} from './utils'

const withSearchComp = (Page) => {
  class GroupEventsSearchResults extends React.Component {
    constructor(props) {
      super(props)
      const { searchState, router } = props
      this.state = {
        searchState,
        lastRouter: router,
        aroundLatLng: searchState.aroundLatLng,
        aroundRadius: milesToMeters(50),
      }
    }

    static async getInitialProps(props) {
      const { asPath, query } = props
      const searchState = await pathToSearchState(asPath, query.param)

      let resultsState = null
      if (!process.browser) {
        // pre-hydrate search results when server rendering
        resultsState = await findResultsState(GroupEventsSearchFindResultsState, {
          ...DEFAULT_PROPS,
          searchState,
          aroundLatLng: searchState.aroundLatLng,
        })
      }
      return {
        resultsState,
        searchState,
      }
    }

    static async getDerivedStateFromProps(props, state) {
      if (!isEqual(state.lastRouter, props.router)) {
        return {
          searchState: await pathToSearchState(props.router.asPath, Rpath(['router', 'query', 'param'], props)),
          lastRouter: props.router,
        }
      }

      return null
    }

    onSearchStateChange = (searchState) => {
      const { aroundLatLng } = this.state
      clearTimeout(this.debouncedSetState)
      this.debouncedSetState = setTimeout(async () => {
        const href = await searchStateToURL(searchState, aroundLatLng)
        Router.push(window.location.pathname, href, {
          shallow: true,
        })
      }, updateAfterMilliseconds)
      this.setState({ searchState })
    }

    setAroundLatLng = (locationStr) => {
      const { searchState } = this.state
      this.setState({
        aroundLatLng: locationStr,
      }, () => this.onSearchStateChange(searchState))
    }

    setAroundRadius = (radiusStr) => {
      this.setState({
        aroundRadius: radiusStr,
      })
    }

    render() {
      const { searchState, aroundLatLng, aroundRadius } = this.state
      const { resultsState } = this.props
      return (
        <Page
          searchClient={searchClient}
          {...DEFAULT_PROPS}
          searchState={searchState}
          resultsState={resultsState}
          onSearchStateChange={this.onSearchStateChange}
          createURL={createURL}
          aroundLatLng={aroundLatLng}
          aroundRadius={aroundRadius}
          setAroundLatLng={this.setAroundLatLng}
          setAroundRadius={this.setAroundRadius}
          placeName={searchState.placeName}
        />
      )
    }
  }

  GroupEventsSearchResults.propTypes = {
    searchState: PropTypes.object,
    router: PropTypes.any,
    resultsState: PropTypes.object,
  }

  return GroupEventsSearchResults
}

export default withSearchComp
